"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getImageByCategories = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));
var _Icon = _interopRequireDefault(require("@airasia/phoenix-components/components/Icon"));
var _Button = _interopRequireDefault(require("@airasia/phoenix-components/components/Button"));
var _Text = _interopRequireDefault(require("@airasia/phoenix-components/components/Text"));
var _Rating = _interopRequireDefault(require("@airasia/phoenix-components/components/Rating"));
var _Review = _interopRequireDefault(require("@airasia/phoenix-components/components/Review"));
var _ImageGallery = _interopRequireDefault(require("../ImageGallery.proptypes"));
var _constant = require("./constant");
var _excluded = ["category"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "ImageGalleryDesktop__Wrapper",
  componentId: "sc-13vqrf1-0"
})(["width:100%;height:100%;"]);
Wrapper.displayName = 'Wrapper';
var Content = _styledComponents.default.div.withConfig({
  displayName: "ImageGalleryDesktop__Content",
  componentId: "sc-13vqrf1-1"
})(["width:100%;height:100%;display:flex;justify-content:space-between;flex-direction:column;background:", ";"], function (_ref) {
  var theme = _ref.theme,
    move = _ref.move;
  return move ? theme.colors.default : theme.colors.neutral;
});
var Main = _styledComponents.default.div.withConfig({
  displayName: "ImageGalleryDesktop__Main",
  componentId: "sc-13vqrf1-2"
})(["display:flex;height:100%;padding-bottom:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.XSmall;
});
var Nav = _styledComponents.default.div.withConfig({
  displayName: "ImageGalleryDesktop__Nav",
  componentId: "sc-13vqrf1-3"
})(["display:flex;margin-bottom:", ";flex-direction:column;justify-content:start;"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.XSmall;
});
var Article = _styledComponents.default.div.withConfig({
  displayName: "ImageGalleryDesktop__Article",
  componentId: "sc-13vqrf1-4"
})(["flex-grow:1;display:grid;grid-template-columns:auto 1fr auto;"]);
var ArrowWrapper = _styledComponents.default.div.withConfig({
  displayName: "ImageGalleryDesktop__ArrowWrapper",
  componentId: "sc-13vqrf1-5"
})(function (_ref4) {
  var theme = _ref4.theme,
    visible = _ref4.visible;
  return "\n  display: flex;\n  align-items: center;\n  margin-top: ".concat(theme.space.large, ";\n  opacity: ").concat(visible ? '1' : '0', ";\n  &:hover {\n    cursor: ").concat(visible ? 'pointer' : 'default', ";\n    filter: drop-shadow(0px 0px ").concat(theme.space.micro, " ").concat(theme.colors.default, ");\n  }");
});
ArrowWrapper.displayName = 'ArrowWrapper';
var CenterBox = _styledComponents.default.div.withConfig({
  displayName: "ImageGalleryDesktop__CenterBox",
  componentId: "sc-13vqrf1-6"
})(function (_ref5) {
  var width = _ref5.width,
    height = _ref5.height,
    theme = _ref5.theme;
  return "\n    height: ".concat(height || 'auto', ";\n    width: ").concat(width || 'auto', ";\n    min-width: 400px;\n    min-height: 400px;\n    display: grid;\n    margin-top: ").concat(theme.space.large, ";\n    position: relative;\n  ");
});
var PreviewImage = _styledComponents.default.img.withConfig({
  displayName: "ImageGalleryDesktop__PreviewImage",
  componentId: "sc-13vqrf1-7"
})(["width:100%;height:75vh;object-fit:cover;border-radius:", ";"], function (_ref6) {
  var theme = _ref6.theme,
    move = _ref6.move;
  return move ? theme.borderRadius.XXnormal : theme.borderRadius.normal;
});
PreviewImage.displayName = 'PreviewImage';
var PreviewImageInfo = _styledComponents.default.div.withConfig({
  displayName: "ImageGalleryDesktop__PreviewImageInfo",
  componentId: "sc-13vqrf1-8"
})(["width:100%;height:", ";position:absolute;bottom:0;left:0;display:flex;justify-content:space-between;padding:0 ", ";box-sizing:border-box;background:linear-gradient(0,rgba(0,0,0,0.6) 0%,rgba(0,0,0,0) 100%);"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.space.large;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.space.standard;
});
var Aside = _styledComponents.default.div.withConfig({
  displayName: "ImageGalleryDesktop__Aside",
  componentId: "sc-13vqrf1-9"
})(["min-width:400px;display:flex;flex-direction:column;justify-content:space-between;"]);
var CloseButton = _styledComponents.default.div.withConfig({
  displayName: "ImageGalleryDesktop__CloseButton",
  componentId: "sc-13vqrf1-10"
})(function (_ref9) {
  var theme = _ref9.theme;
  return "\n  text-align: right;\n  padding: ".concat(theme.space.tiny, ";\n  &:hover {\n    cursor: pointer;\n    filter: drop-shadow(0px 0px ").concat(theme.space.micro, " ").concat(theme.colors.default, ");\n  }");
});
CloseButton.displayName = 'CloseButton';
var HotelInfo = _styledComponents.default.div.withConfig({
  displayName: "ImageGalleryDesktop__HotelInfo",
  componentId: "sc-13vqrf1-11"
})(function (_ref10) {
  var theme = _ref10.theme;
  return "\n    display: flex;\n    flex-direction: column;\n    padding: 0 ".concat(theme.space.large, " 0 ").concat(theme.space.small, ";\n  ");
});
var HotelTitle = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "ImageGalleryDesktop__HotelTitle",
  componentId: "sc-13vqrf1-12"
})(["font-size:", ";line-height:", ";"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.fontSize.titleNormal;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.lineHeight.titleSmall;
});
var RoomName = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "ImageGalleryDesktop__RoomName",
  componentId: "sc-13vqrf1-13"
})(["font-size:", ";line-height:", ";margin-bottom:", ";"], function (_ref13) {
  var theme = _ref13.theme;
  return theme.fontSize.titleNormal;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.lineHeight.titleSmall;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.space.micro;
});
var RoomBedGroupText = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "ImageGalleryDesktop__RoomBedGroupText",
  componentId: "sc-13vqrf1-14"
})(["font-size:", ";"], function (_ref16) {
  var theme = _ref16.theme;
  return theme.fontSize.small;
});
var RoomAmenities = (0, _styledComponents.default)(Wrapper).withConfig({
  displayName: "ImageGalleryDesktop__RoomAmenities",
  componentId: "sc-13vqrf1-15"
})(["margin-top:", ";color:", ";font-family:", ";font-weight:", ";"], function (_ref17) {
  var theme = _ref17.theme;
  return theme.space.XSmall;
}, function (_ref18) {
  var theme = _ref18.theme,
    move = _ref18.move;
  return move ? theme.colors.neutral : theme.colors.greyLight;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.fontFamily.default;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.fontWeight.normal;
});
var RatingAndReview = _styledComponents.default.div.withConfig({
  displayName: "ImageGalleryDesktop__RatingAndReview",
  componentId: "sc-13vqrf1-16"
})(function (_ref21) {
  var theme = _ref21.theme;
  return "\n  padding: ".concat(theme.space.tiny, " 0;\n  .rating {\n    margin-bottom: ").concat(theme.space.micro, ";\n  }\n");
});
var SelectRoomButton = (0, _styledComponents.default)(_Button.default).withConfig({
  displayName: "ImageGalleryDesktop__SelectRoomButton",
  componentId: "sc-13vqrf1-17"
})(["margin:0;"]);
SelectRoomButton.displayName = 'SelectRoomButton';
var categoryListIsHorizontalScrollStyle = (0, _styledComponents.css)(["display:block;border-bottom:0;overflow-y:hidden;overflow-x:auto;scroll-behavior:smooth;white-space:nowrap;position:relative;padding-bottom:10px;&::before{content:'';position:absolute;border-top:1px solid ", ";bottom:0;left:0;width:100%;}&::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 ", " rgba(0,0,0,0.3);background-color:", ";}&::-webkit-scrollbar{height:", ";background-color:", ";}&::-webkit-scrollbar-thumb{background-color:", ";}"], function (_ref22) {
  var theme = _ref22.theme;
  return theme.colors.greyDarker;
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.space.micro;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.colors.greyDarker;
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.space.micro;
}, function (_ref26) {
  var theme = _ref26.theme;
  return theme.colors.greyDarker;
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.colors.default;
});
var CategoryList = _styledComponents.default.ul.withConfig({
  displayName: "ImageGalleryDesktop__CategoryList",
  componentId: "sc-13vqrf1-18"
})(["display:flex;flex-wrap:wrap;font-size:", ";margin-bottom:0;padding:0 ", ";border-bottom:1px solid ", ";", ""], function (_ref28) {
  var theme = _ref28.theme;
  return theme.fontSize.normal;
}, function (_ref29) {
  var theme = _ref29.theme;
  return theme.space.large;
}, function (_ref30) {
  var theme = _ref30.theme,
    move = _ref30.move;
  return move ? theme.colors.greyLight : theme.colors.greyDarker;
}, function (_ref31) {
  var isHorizontalScroll = _ref31.isHorizontalScroll;
  return isHorizontalScroll && categoryListIsHorizontalScrollStyle;
});
var selectedCategoryStyle = (0, _styledComponents.css)(["&::before{border-bottom:2px solid ", ";width:100%;content:'';position:absolute;left:50%;bottom:0;margin-bottom:-1px;transform:translateX(-50%);}"], function (_ref32) {
  var theme = _ref32.theme,
    move = _ref32.move;
  return move ? theme.colors.secondary : theme.colors.primary;
});
var CategoryItem = _styledComponents.default.li.withConfig({
  displayName: "ImageGalleryDesktop__CategoryItem",
  componentId: "sc-13vqrf1-19"
})(["position:relative;color:", ";margin:", ";line-height:", ";cursor:pointer;list-style:none;border-bottom:none;&:first-child{margin-left:0;}&:last-child{margin-right:0;}", " ", ""], function (_ref33) {
  var theme = _ref33.theme,
    move = _ref33.move;
  return move ? theme.colors.greyDarker : theme.colors.default;
}, function (_ref34) {
  var theme = _ref34.theme;
  return "".concat(theme.space.micro, " ").concat(theme.space.XSmall, " 0");
}, function (_ref35) {
  var theme = _ref35.theme;
  return theme.lineHeight.titleNormal;
}, function (_ref36) {
  var selected = _ref36.selected;
  return selected && selectedCategoryStyle;
}, function (_ref37) {
  var isHorizontalScroll = _ref37.isHorizontalScroll;
  return isHorizontalScroll && "\n      display: inline-block;\n    ";
});
CategoryItem.displayName = 'CategoryItem';
var ImageList = _styledComponents.default.ul.withConfig({
  displayName: "ImageGalleryDesktop__ImageList",
  componentId: "sc-13vqrf1-20"
})(["text-align:left;overflow:auto;white-space:nowrap;margin:0 ", ";padding:", " 0;scroll-behavior:smooth;&::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 ", " rgba(0,0,0,0.3);background-color:", ";}&::-webkit-scrollbar{height:", ";background-color:", ";}&::-webkit-scrollbar-thumb{background-color:", ";}"], function (_ref38) {
  var theme = _ref38.theme;
  return theme.space.large;
}, function (_ref39) {
  var theme = _ref39.theme;
  return theme.space.standard;
}, function (_ref40) {
  var theme = _ref40.theme;
  return theme.space.micro;
}, function (_ref41) {
  var theme = _ref41.theme;
  return theme.colors.greyDarker;
}, function (_ref42) {
  var theme = _ref42.theme;
  return theme.space.micro;
}, function (_ref43) {
  var theme = _ref43.theme;
  return theme.colors.greyDarker;
}, function (_ref44) {
  var theme = _ref44.theme;
  return theme.colors.default;
});
var ImageItemBox = _styledComponents.default.li.withConfig({
  displayName: "ImageGalleryDesktop__ImageItemBox",
  componentId: "sc-13vqrf1-21"
})(["display:inline-block;width:120px;height:80px;position:relative;cursor:pointer;background-size:cover;margin:0;padding:0;list-style:none;&:not(:first-child){margin-left:", ";}"], function (_ref45) {
  var theme = _ref45.theme;
  return theme.space.small;
});
ImageItemBox.displayName = 'ImageItemBox';
var ImageItem = _styledComponents.default.img.withConfig({
  displayName: "ImageGalleryDesktop__ImageItem",
  componentId: "sc-13vqrf1-22"
})(["width:100%;height:100%;object-fit:cover;border-radius:", ";"], function (_ref46) {
  var theme = _ref46.theme,
    move = _ref46.move;
  return move ? theme.borderRadius.XXnormal : theme.borderRadius.normal;
});
var ImageItemActiveBorder = _styledComponents.default.div.withConfig({
  displayName: "ImageGalleryDesktop__ImageItemActiveBorder",
  componentId: "sc-13vqrf1-23"
})(["position:absolute;top:0;left:0;width:100%;height:100%;border:2px solid ", ";box-sizing:border-box;border-radius:", ";"], function (_ref47) {
  var theme = _ref47.theme;
  return theme.colors.primary;
}, function (_ref48) {
  var theme = _ref48.theme,
    move = _ref48.move;
  return move ? theme.borderRadius.XXnormal : theme.borderRadius.normal;
});
var getImageByCategories = function getImageByCategories(images, allLabel) {
  var categoryMap = {};
  var imageByCategories = (0, _defineProperty2.default)({}, _constant.ALL_CATEGORY_ID, []);
  images.forEach(function (_ref49) {
    var category = _ref49.category,
      image = (0, _objectWithoutProperties2.default)(_ref49, _excluded);
    if (category) {
      var id = category.id,
        name = category.name;
      if (id) {
        if (categoryMap[id]) {
          categoryMap[id].count += 1;
        } else {
          categoryMap[id] = {
            id: id,
            name: name,
            count: 1
          };
        }
        if (imageByCategories[id]) {
          imageByCategories[id].push(image);
        } else {
          imageByCategories[id] = [image];
        }
      }
    }
    imageByCategories[_constant.ALL_CATEGORY_ID].push(image);
  });
  var categories = Object.entries(categoryMap).map(function (_ref50) {
    var _ref51 = (0, _slicedToArray2.default)(_ref50, 2),
      _ref51$ = _ref51[1],
      id = _ref51$.id,
      name = _ref51$.name,
      count = _ref51$.count;
    return {
      id: id,
      name: name,
      count: count
    };
  });
  categories.sort(function (a, b) {
    return a.name > b.name ? 1 : -1;
  });
  var catAll = {
    id: _constant.ALL_CATEGORY_ID,
    name: allLabel,
    count: images.length
  };
  categories.unshift(catAll);
  return [categories, imageByCategories];
};
exports.getImageByCategories = getImageByCategories;
var ImageGalleryDesktop = function ImageGalleryDesktop(_ref52) {
  var accessible = _ref52.accessible,
    theme = _ref52.theme,
    className = _ref52.className,
    images = _ref52.images,
    hotelDetail = _ref52.hotelDetail,
    allLabel = _ref52.allLabel,
    selectRoomLabel = _ref52.selectRoomLabel,
    onSelectRoom = _ref52.onSelectRoom,
    onClose = _ref52.onClose,
    imageWidth = _ref52.imageWidth,
    imageHeight = _ref52.imageHeight,
    customProperties = _ref52.customProperties,
    onImageEnlarge = _ref52.onImageEnlarge,
    onClickArrows = _ref52.onClickArrows,
    roomDetail = _ref52.roomDetail,
    move = _ref52.move;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var imageListRef = (0, _react.useRef)();
  var tabIndex = !accessible ? '-1' : '0';
  var _useState = (0, _react.useState)(_constant.ALL_CATEGORY_ID),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    selectedCatId = _useState2[0],
    setSelectedCatId = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    selectedImage = _useState4[0],
    setSelectedImage = _useState4[1];
  var _useMemo = (0, _react.useMemo)(function () {
      return getImageByCategories(images, allLabel);
    }, [images, allLabel]),
    _useMemo2 = (0, _slicedToArray2.default)(_useMemo, 2),
    categories = _useMemo2[0],
    imageByCategories = _useMemo2[1];
  var getNextAndPreviousImages = (0, _react.useCallback)(function (imgIndex, catId) {
    var catIndex = categories.findIndex(function (category) {
      return category.id === catId;
    });
    var next;
    if (imgIndex < imageByCategories[catId].length - 1) {
      next = {
        imgIndex: imgIndex + 1,
        catId: catId
      };
    } else if (catIndex < categories.length - 1) {
      var nextCategory = categories[catIndex + 1];
      var nextCategoryImages = imageByCategories[nextCategory.id];
      if (nextCategoryImages.length > 0) {
        next = {
          imgIndex: 0,
          catId: nextCategory.id
        };
      }
    }
    var prev;
    if (imgIndex > 0) {
      prev = {
        imgIndex: imgIndex - 1,
        catId: catId
      };
    } else if (catIndex > 0) {
      var prevCategory = categories[catIndex - 1];
      var prevCategoryImages = imageByCategories[prevCategory.id];
      if (prevCategoryImages.length > 0) {
        prev = {
          imgIndex: prevCategoryImages.length - 1,
          catId: prevCategory.id
        };
      }
    }
    return {
      next: next,
      prev: prev
    };
  }, [categories, imageByCategories]);
  var scrollToItem = function scrollToItem(index) {
    var imageList = imageListRef.current;
    if (imageList && imageList.scrollTo) {
      var scrollLeft = imageList.scrollLeft,
        offsetWidth = imageList.offsetWidth;
      var itemOffsetLeft = _constant.IMAGE_ITEM_WIDTH * index;
      var itemOffsetRight = _constant.IMAGE_ITEM_WIDTH * (index + 1);
      var inTheCurrentViewport = scrollLeft < itemOffsetLeft && scrollLeft + offsetWidth > itemOffsetRight;
      if (!inTheCurrentViewport) {
        imageList.scrollTo({
          left: itemOffsetLeft,
          behavior: 'smooth'
        });
      }
    }
  };
  (0, _react.useEffect)(function () {
    if (images.length > 0) {
      var imgIndex = 0;
      var _getNextAndPreviousIm = getNextAndPreviousImages(imgIndex, _constant.ALL_CATEGORY_ID),
        next = _getNextAndPreviousIm.next;
      setSelectedImage(_objectSpread(_objectSpread({}, images[0]), {}, {
        imgIndex: imgIndex,
        next: next
      }));
    }
  }, [images, getNextAndPreviousImages]);
  (0, _react.useEffect)(function () {
    if (selectedImage) {
      scrollToItem(selectedImage.imgIndex);
    }
  }, [selectedImage]);
  var gotoImage = function gotoImage(imgIndex, catId) {
    var _getNextAndPreviousIm2 = getNextAndPreviousImages(imgIndex, catId),
      next = _getNextAndPreviousIm2.next,
      prev = _getNextAndPreviousIm2.prev;
    setSelectedImage(_objectSpread(_objectSpread({}, imageByCategories[catId][imgIndex]), {}, {
      imgIndex: imgIndex,
      next: next,
      prev: prev
    }));
    setSelectedCatId(catId);
  };
  var gotoNextImage = function gotoNextImage() {
    if (selectedImage.next) {
      var _selectedImage$next = selectedImage.next,
        imgIndex = _selectedImage$next.imgIndex,
        catId = _selectedImage$next.catId;
      gotoImage(imgIndex, catId);
      onClickArrows();
    }
  };
  var gotoPrevImage = function gotoPrevImage() {
    if (selectedImage.prev) {
      var _selectedImage$prev = selectedImage.prev,
        imgIndex = _selectedImage$prev.imgIndex,
        catId = _selectedImage$prev.catId;
      gotoImage(imgIndex, catId);
      onClickArrows();
    }
  };
  var handleSelectCategory = function handleSelectCategory(catId) {
    setSelectedCatId(catId);
    if (imageByCategories[catId].length > 0) {
      var imgIndex = 0;
      var _getNextAndPreviousIm3 = getNextAndPreviousImages(imgIndex, catId),
        next = _getNextAndPreviousIm3.next,
        prev = _getNextAndPreviousIm3.prev;
      setSelectedImage(_objectSpread(_objectSpread({}, imageByCategories[catId][imgIndex]), {}, {
        imgIndex: imgIndex,
        next: next,
        prev: prev
      }));
    } else {
      setSelectedImage(undefined);
    }
  };
  var handleKeydown = function handleKeydown(event) {
    event.preventDefault();
    switch (event.key) {
      case _constant.ARROW_LEFT:
        {
          gotoPrevImage();
          break;
        }
      case _constant.ARROW_RIGHT:
        {
          gotoNextImage();
          break;
        }
      case 'Tab':
        {
          var catIndex = categories.findIndex(function (category) {
            return category.id === selectedCatId;
          });
          var nextCatIndex;
          if (event.shiftKey) {
            // shift + tab => go to previous category
            nextCatIndex = catIndex > 0 ? catIndex - 1 : categories.length - 1;
          } else {
            // tab => go to next category
            nextCatIndex = catIndex < categories.length - 1 ? catIndex + 1 : 0;
          }
          handleSelectCategory(categories[nextCatIndex].id);
          break;
        }
      default:
        break;
    }
  };
  var _ref53 = customProperties || {},
    isHorizontalScroll = _ref53.isHorizontalScroll;
  var getGalleryComponent = function getGalleryComponent() {
    return /*#__PURE__*/_react.default.createElement(Wrapper, (0, _extends2.default)({
      tabIndex: tabIndex,
      onKeyDown: handleKeydown,
      className: className
    }, customProperties), /*#__PURE__*/_react.default.createElement(Content, {
      move: move
    }, /*#__PURE__*/_react.default.createElement(Main, null, /*#__PURE__*/_react.default.createElement(Article, null, /*#__PURE__*/_react.default.createElement(ArrowWrapper, {
      visible: selectedImage && selectedImage.prev,
      onClick: gotoPrevImage
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      color: move ? 'neutral' : 'default',
      fontsize: "titleLarge",
      icon: _constant.CHEVRON_LEFT_ICON
    })), /*#__PURE__*/_react.default.createElement(CenterBox, {
      width: imageWidth,
      height: imageHeight
    }, selectedImage && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(PreviewImage, {
      src: selectedImage.links.big,
      alt: selectedImage.alt || selectedImage.caption || 'TBD',
      move: move
    }), !roomDetail && /*#__PURE__*/_react.default.createElement(PreviewImageInfo, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      type: "sub",
      bold: true,
      accessible: false,
      color: move ? 'neutral' : 'greyLight'
    }, selectedImage.caption), /*#__PURE__*/_react.default.createElement(_Text.default, {
      type: "sub",
      bold: true,
      accessible: false,
      color: move ? 'neutral' : 'greyLight'
    }, selectedImage.imgIndex + 1, "/", imageByCategories[selectedCatId].length)))), /*#__PURE__*/_react.default.createElement(ArrowWrapper, {
      visible: selectedImage && selectedImage.next,
      onClick: gotoNextImage
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      color: move ? 'neutral' : 'default',
      fontsize: "titleLarge",
      icon: _constant.CHEVRON_RIGHT_ICON
    }))), /*#__PURE__*/_react.default.createElement(Aside, null, /*#__PURE__*/_react.default.createElement(CloseButton, {
      onClick: onClose
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      color: move ? 'neutral' : 'default',
      fontsize: "titleMedium",
      icon: _constant.CLOSE_ICON
    })), hotelDetail && /*#__PURE__*/_react.default.createElement(HotelInfo, null, /*#__PURE__*/_react.default.createElement(HotelTitle, {
      bold: true,
      color: move ? '#4C4C50' : 'greyLight'
    }, hotelDetail.name), /*#__PURE__*/_react.default.createElement(RatingAndReview, null, /*#__PURE__*/_react.default.createElement(_Rating.default, {
      maxRate: _constant.MAX_RATE,
      rate: hotelDetail.rating.rating,
      customProperties: {
        className: 'rating'
      }
    }), /*#__PURE__*/_react.default.createElement(_Review.default, {
      oneline: true,
      data: {
        message: hotelDetail.review.message,
        rating: hotelDetail.review.rating,
        reviewCount: hotelDetail.review.count
      }
    })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(SelectRoomButton, {
      type: "normal",
      size: move ? 'medium' : 'small',
      color: move ? 'secondary' : 'default',
      border: move ? 'secondary' : 'primary',
      backgroundColor: "primary",
      handleClick: onSelectRoom
    }, selectRoomLabel))), roomDetail && /*#__PURE__*/_react.default.createElement(HotelInfo, null, /*#__PURE__*/_react.default.createElement(RoomName, {
      bold: true,
      color: move ? 'neutral' : 'default'
    }, roomDetail.name), /*#__PURE__*/_react.default.createElement(RoomBedGroupText, {
      color: move ? 'neutral' : 'greyLighter'
    }, roomDetail.bedGroup), roomDetail.amenities && /*#__PURE__*/_react.default.createElement(RoomAmenities, {
      move: move
    }, roomDetail.amenities)))), /*#__PURE__*/_react.default.createElement(Nav, null, !roomDetail && /*#__PURE__*/_react.default.createElement(CategoryList, {
      isHorizontalScroll: isHorizontalScroll,
      move: move
    }, categories.map(function (_ref54) {
      var id = _ref54.id,
        name = _ref54.name,
        count = _ref54.count;
      return /*#__PURE__*/_react.default.createElement(CategoryItem, {
        key: id,
        onClick: function onClick() {
          return handleSelectCategory(id);
        },
        selected: id === selectedCatId,
        isHorizontalScroll: isHorizontalScroll,
        move: move
      }, /*#__PURE__*/_react.default.createElement(_Text.default, {
        type: "sub",
        bold: true,
        accessible: false,
        color: move ? id === selectedCatId && 'secondary' || 'greyDarker' : 'greyLight'
      }, name, " (", count, ")"));
    })), /*#__PURE__*/_react.default.createElement(ImageList, {
      ref: imageListRef
    }, imageByCategories[selectedCatId].map(function (image, index) {
      return /*#__PURE__*/_react.default.createElement(ImageItemBox, {
        key: image.id,
        onClick: function onClick() {
          setSelectedImage(_objectSpread(_objectSpread(_objectSpread({}, image), getNextAndPreviousImages(index, selectedCatId)), {}, {
            imgIndex: index
          }));
          onImageEnlarge();
        }
      }, /*#__PURE__*/_react.default.createElement(ImageItem, {
        src: image.links.small,
        alt: image.alt || image.caption || 'TBD',
        move: move
      }), selectedImage && image.id === selectedImage.id && /*#__PURE__*/_react.default.createElement(ImageItemActiveBorder, {
        move: move
      }));
    })))));
  };
  return themeContext ? getGalleryComponent() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getGalleryComponent());
};
ImageGalleryDesktop.propTypes = _ImageGallery.default.PropTypes;
ImageGalleryDesktop.defaultProps = _ImageGallery.default.DefaultProps;
var _default = ImageGalleryDesktop;
exports.default = _default;